import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setLoggedIn, setLoggedOut, loggedIn } from "../auth/authReducer";
import Persistor from '../store/Persistor';
import { setPermittedActions } from "../ui/permittedActionsReducer";
import { changeLoadingState } from "../ui/loadingStateReducer";
import env from "react-dotenv";

let apiCount = 0;

const baseQuery = fetchBaseQuery({
  baseUrl: env.API_HOST || "http://localhost:3000",
  prepareHeaders: (headers, props) => {
    const { getState, extra } = props;
    const { access_token, refresh_token } = getState().auth.token;

    if(extra?.refreshCall && refresh_token) {
      headers.set("Authorization", `Bearer ${refresh_token}`);
    } else if(access_token) {
      headers.set("Authorization", `Bearer ${access_token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result;
  try{
     apiCount++;
    api.dispatch(changeLoadingState({isLoading: true}))
    result = await baseQuery(args, api, extraOptions);
      --apiCount;
    if(apiCount === 0){
      api.dispatch(changeLoadingState({isLoading: false}))
    }
  } catch(error) {
    --apiCount;
    if(apiCount === 0) {
      api.dispatch(changeLoadingState({isLoading: false}))
    }
  }
  if (result?.error?.status === 403) {
    // send refresh token to get new access token
    const refreshResult = await baseQuery({
      method: "POST",
      url: "/api/v2/tokens/refresh"
    }, {...api, extra: { refreshCall: true }}, extraOptions);
    if(refreshResult?.error?.status === 403 || refreshResult?.error?.status === 401) {
      api.dispatch(setLoggedOut());
    } else if(refreshResult?.data) {
      const { access_token } = refreshResult.data;
      api.dispatch(setLoggedIn(loggedIn(api.getState().auth.user, { ...api.getState().auth.token, ...{ access_token: access_token } })));
      // retry the original query with new access token
      result = await baseQuery(args, api, extraOptions);  
    }
  } else {
    for (let pair of result.meta.response.headers.entries()) {
      if(pair[0] === 'x-permchk' && pair[1] !== Persistor.get('x-permchk')) {
        const actionsData = await baseQuery({
          url: "/api/v3/crm/user_actions",
          method: "GET"
        }, api, extraOptions);
        api.dispatch(
          setPermittedActions({
            permittedActions: actionsData.data.data.permitted_actions,
          })
        );
        Persistor.store("x-permchk", pair[1])
      }

      if(pair[0] === 'x-ushash' && pair[1] !== Persistor.get('x-ushash')) {
        // Persistor.store("x-ushash", pair[1])
      }
    }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({}),
});
